var render = function render(){
  var _vm$uploaded, _vm$uploaded2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "center",
    "class": _vm.showFiles && ((_vm$uploaded = _vm.uploaded) === null || _vm$uploaded === void 0 ? void 0 : _vm$uploaded.length) === 0 ? "".concat(_vm.classCst, " uploaded") : _vm.classCst,
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.openDocumentCloudPopUp.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "link-icon-text",
    on: {
      "click": _vm.openDocumentCloudPopUp
    }
  }, [_vm.iconButton ? _c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg"
    }
  }) : _vm._e(), _vm.iconButtonSign ? _c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg",
      "alt": ""
    }
  }) : _vm._e(), _vm.textIconButton ? _c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg"
    }
  }) : _vm._e(), _vm.leadingText ? _c('span', {
    staticClass: "document-upload-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "cloud",
      "size": 20
    }
  })], 1) : _vm._e(), _vm.leadingText ? _c('span', [_vm._v(_vm._s(typeof _vm.leadingText === "string" ? _vm.leadingText : "nahrať"))]) : _vm._e(), _vm.textIconButton ? _c('span', [_vm._v("cloud")]) : _vm._e()]), _vm.textButton ? _c('div', {
    "class": {
      'missing-file-title': _vm.showFiles && ((_vm$uploaded2 = _vm.uploaded) === null || _vm$uploaded2 === void 0 ? void 0 : _vm$uploaded2.length) !== 0
    },
    on: {
      "click": _vm.openDocumentCloudPopUp
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])]) : _vm._e(), _vm._l(_vm.uploaded, function (file, index) {
    return _vm.showFiles && _vm.uploaded ? _c('div', {
      key: index + 'cldfil',
      staticClass: "link-block-7 w-inline-block justify-content-between"
    }, [_c('div', {
      staticClass: "d-flex flex-row"
    }, [_c('div', {
      staticClass: "small fileName"
    }, [_vm._v(_vm._s(file.name))])]), file.name.endsWith('.pdf') ? _c('a', {
      staticClass: "text-cta pointer",
      attrs: {
        "href": file.file,
        "target": "_blank"
      }
    }, [_vm._v(" STIAHNUŤ ")]) : _c('div', {
      staticClass: "text-cta pointer",
      on: {
        "click": function click($event) {
          return _vm.download(file);
        }
      }
    }, [_vm._v(" STIAHNUŤ ")]), _vm.allowUnassign ? _c('button', {
      staticClass: "picked-file-remove",
      attrs: {
        "type": "button",
        "title": "Odobrať z požadovaného podkladu",
        "aria-label": "Odobrať z požadovaného podkladu"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.unassignFile(file);
        }
      }
    }, [_vm._v(" × ")]) : _vm._e()]) : _vm._e();
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }